import Accordion from "./components/Accordion";
import Menu from "./components/Menu";
import DonationForm from "./components/DonationForm";

/**
 * Bind all functions on pageload
 */
const init = () => {
  // Get scope for functions
  const scope = document.querySelector("body");

  // Menu
  if (scope) {
    const menu = new Menu(scope);

    menu.init();

    const accordion = new Accordion(scope);
    accordion.init();

    const donationForm = new DonationForm(
      "donation-form",
      "donation-form__field--radios",
      "donation-form__field--checkbox",
      "donation-form__field--custom-amount",
    );

    donationForm.init();
  }
};

window.addEventListener("load", init, false);
